// Shared SVG icon sprite (UI System v2 — stroke icons `i-*`, filled brand glyphs `g-*`).
// <IconSprite /> is mounted once in LangLayout; <Icon name="i-check" /> references a symbol.
// Symbols are ported verbatim from the landing v4 prototype (docs/design/landing-v4).

export type IconName =
  | "i-bell"
  | "i-chart"
  | "i-search"
  | "i-sliders"
  | "i-more"
  | "i-car"
  | "i-device"
  | "i-house"
  | "i-check"
  | "i-x"
  | "i-docPlus"
  | "i-pen"
  | "i-lock"
  | "i-clock"
  | "i-chevDown"
  | "i-arrowDown"
  | "i-arrowR"
  | "i-sms"
  | "i-mail"
  | "i-insta"
  | "i-rows"
  | "i-archive"
  | "i-sort"
  | "i-wrench"
  | "i-back"
  | "i-chevR"
  | "i-home"
  | "i-file"
  | "i-inbox"
  | "i-wallet"
  | "i-userPlus"
  | "i-debtIn"
  | "i-arrowUp"
  | "i-cal"
  | "i-plus"
  | "i-menu"
  | "i-handshake"
  | "i-info"
  | "i-alert"
  | "i-camera"
  | "g-apple"
  | "g-play"
  | "g-tg";

export function IconSprite() {
  return (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true" focusable="false">
      <symbol id="i-bell" viewBox="0 0 24 24"><path d="M18 9a6 6 0 1 0-12 0c0 6-2.5 7.5-2.5 7.5h17S18 15 18 9" /><path d="M10 20a2.2 2.2 0 0 0 4 0" /></symbol>
      <symbol id="i-chart" viewBox="0 0 24 24"><path d="M4 20h16M7 16.5v-5M12 16.5V7M17 16.5v-8" /></symbol>
      <symbol id="i-search" viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.5" /><path d="M16 16l4.5 4.5" /></symbol>
      <symbol id="i-sliders" viewBox="0 0 24 24"><path d="M4 6h9M17 6h3" /><circle cx="14.5" cy="6" r="2" /><path d="M4 12h3M11 12h9" /><circle cx="8.5" cy="12" r="2" /><path d="M4 18h9M17 18h3" /><circle cx="14.5" cy="18" r="2" /></symbol>
      <symbol id="i-more" viewBox="0 0 24 24"><circle cx="12" cy="5.5" r="1.7" fill="currentColor" stroke="none" /><circle cx="12" cy="12" r="1.7" fill="currentColor" stroke="none" /><circle cx="12" cy="18.5" r="1.7" fill="currentColor" stroke="none" /></symbol>
      <symbol id="i-car" viewBox="0 0 24 24"><path d="M4.5 13l1.4-4.1A2 2 0 0 1 7.8 7.5h8.4a2 2 0 0 1 1.9 1.4l1.4 4.1" /><rect x="3" y="13" width="18" height="5" rx="1.6" /><path d="M6.5 18v2M17.5 18v2M7 15.5h.01M17 15.5h.01" /></symbol>
      <symbol id="i-device" viewBox="0 0 24 24"><rect x="7" y="2.5" width="10" height="19" rx="2.5" /><path d="M11 18.5h2" /></symbol>
      <symbol id="i-house" viewBox="0 0 24 24"><path d="M4 10.5L12 4l8 6.5V20a1 1 0 0 1-1 1h-4.5v-6h-5v6H5a1 1 0 0 1-1-1z" /></symbol>
      <symbol id="i-check" viewBox="0 0 24 24"><path d="M4 12.5L9.5 18L20 6.5" /></symbol>
      <symbol id="i-x" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" /></symbol>
      <symbol id="i-docPlus" viewBox="0 0 24 24"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /><path d="M12 12v5M9.5 14.5h5" /></symbol>
      <symbol id="i-pen" viewBox="0 0 24 24"><path d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16zM13.5 6.5l4 4" /></symbol>
      <symbol id="i-lock" viewBox="0 0 24 24"><rect x="5" y="10.5" width="14" height="10" rx="2.5" /><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" /></symbol>
      <symbol id="i-clock" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 2" /></symbol>
      <symbol id="i-chevDown" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6" /></symbol>
      <symbol id="i-arrowDown" viewBox="0 0 24 24"><path d="M12 4v16M5 13l7 7 7-7" /></symbol>
      <symbol id="i-arrowR" viewBox="0 0 24 24"><path d="M4 12h16M13 5l7 7-7 7" /></symbol>
      <symbol id="i-sms" viewBox="0 0 24 24"><rect x="3.5" y="5" width="17" height="12" rx="2.5" /><path d="M8 17l-2 3.5V17M8 11h.01M12 11h.01M16 11h.01" /></symbol>
      <symbol id="i-mail" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2.5" /><path d="M3.5 7l8.5 6 8.5-6" /></symbol>
      <symbol id="i-insta" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><path d="M17.5 6.5h.01" /></symbol>
      <symbol id="i-rows" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="7" rx="1.5" /><rect x="4" y="13" width="16" height="7" rx="1.5" /></symbol>
      <symbol id="i-archive" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="5" rx="1.5" /><path d="M5 9v9.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V9M10 13h4" /></symbol>
      <symbol id="i-sort" viewBox="0 0 24 24"><path d="M7 4v16M3.5 16.5L7 20l3.5-3.5M13 6h8M13 11h6M13 16h4" /></symbol>
      <symbol id="i-wrench" viewBox="0 0 24 24"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.8-3.8a6 6 0 0 1-7.9 7.9l-6.9 6.9a2.1 2.1 0 0 1-3-3l6.9-6.9a6 6 0 0 1 7.9-7.9z" /></symbol>
      <symbol id="i-back" viewBox="0 0 24 24"><path d="M15 4.5L7.5 12l7.5 7.5" /></symbol>
      <symbol id="i-chevR" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" /></symbol>
      <symbol id="i-home" viewBox="0 0 24 24"><path d="M4 10.5L12 4l8 6.5V19a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19z" /><path d="M9.5 20v-6h5v6" /></symbol>
      <symbol id="i-file" viewBox="0 0 24 24"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5M9 13h6M9 17h4" /></symbol>
      <symbol id="i-inbox" viewBox="0 0 24 24"><path d="M4 5h16v14H4z" /><path d="M4 13h4l2 3h4l2-3h4" /></symbol>
      <symbol id="i-wallet" viewBox="0 0 24 24"><path d="M5 4h13a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2" /><path d="M15 12.5h5" /></symbol>
      <symbol id="i-userPlus" viewBox="0 0 24 24"><circle cx="10" cy="8" r="3.5" /><path d="M4 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" /><path d="M18.5 7v5M16 9.5h5" /></symbol>
      <symbol id="i-debtIn" viewBox="0 0 24 24"><path d="M19 5L9 15" /><path d="M16 15H9V8" /><path d="M5 20h14" /></symbol>
      <symbol id="i-arrowUp" viewBox="0 0 24 24"><path d="M12 20V4M5 11l7-7 7 7" /></symbol>
      <symbol id="i-cal" viewBox="0 0 24 24"><rect x="4" y="5" width="16" height="15" rx="2.5" /><path d="M4 10h16M9 3v4M15 3v4" /></symbol>
      <symbol id="i-plus" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" /></symbol>
      <symbol id="i-menu" viewBox="0 0 24 24"><path d="M4 7h16M4 12h16M4 17h10" /></symbol>
      <symbol id="i-handshake" viewBox="0 0 24 24"><path d="M3 7l4-2 5 2 5-2 4 2v7l-4 4-5-3-5 3-4-4z" /><path d="M12 7v7" /></symbol>
      <symbol id="i-info" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></symbol>
      <symbol id="i-alert" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M12 7.5v5.5M12 16.5h.01" /></symbol>
      <symbol id="i-camera" viewBox="0 0 24 24"><path d="M4 8.5A1.5 1.5 0 0 1 5.5 7h2L9 4.5h6L16.5 7h2A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5z" /><circle cx="12" cy="12.5" r="3.5" /></symbol>
      {/* Store marks: Simple Icons 16.34 (CC0) — the prototype's hand-drawn glyphs were malformed. */}
      <symbol id="g-apple" viewBox="0 0 24 24"><path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" /></symbol>
      <symbol id="g-play" viewBox="0 0 24 24"><path d="M22.018 13.298l-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 0 1 0 2.594zM1.337.924a1.486 1.486 0 0 0-.112.568v21.017c0 .217.045.419.124.6l11.155-11.087L1.337.924zm12.207 10.065l3.258-3.238L3.45.195a1.466 1.466 0 0 0-.946-.179l11.04 10.973zm0 2.067l-11 10.933c.298.036.612-.016.906-.183l13.324-7.54-3.23-3.21z" /></symbol>
      <symbol id="g-tg" viewBox="0 0 24 24"><path d="M21.9 4.3 18.6 20c-.2 1-.9 1.3-1.8.8l-4.9-3.6-2.4 2.3c-.3.3-.5.5-1 .5l.3-4.9 9-8.1c.4-.3-.1-.5-.6-.2L6.1 13.2l-4.8-1.5c-1-.3-1-1 .2-1.5l18.8-7.2c.9-.3 1.6.2 1.4 1.3z" /></symbol>
    </svg>
  );
}

interface IconProps {
  name: IconName;
  /** CSS class; defaults to `ic` (stroke icon). Use `glyph` for filled `g-*` symbols. */
  className?: string;
}

export function Icon({ name, className }: IconProps) {
  return (
    <svg className={className ?? "ic"} aria-hidden="true" focusable="false">
      <use href={"#" + name} />
    </svg>
  );
}
